module.exports = __webpack_public_path__ + "static/media/penacova-1.f4bd2e50.jpg";